module.exports = __webpack_public_path__ + "img/9788963707822.6006fd12.jpg";